import dolarIcon from "../assets/dollar-icon.svg";

export default function SalaryField({
  label,
  name,
  placeholder,
  value,
  handleInput,
}) {
  return (
    <>
      <div className="form-group">
        <label>{label}</label>
        <div className="profile-edit-icon-wrapper">
          <div className="profile-edit-icon-wrapper__img">
            <img src={dolarIcon} alt="telegram" />
          </div>
          <input
            type="text"
            name={name}
            value={value}
            onChange={handleInput}
            maxLength="12"
            placeholder={placeholder}
          />
        </div>
      </div>
    </>
  );
}
